import { __extends } from "tslib";
import { Graphics as AwayGraphics } from '@awayjs/graphics';
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var Graphics = /** @class */ (function (_super) {
    __extends(Graphics, _super);
    function Graphics(adaptee) {
        if (adaptee === void 0) { adaptee = null; }
        var _this = _super.call(this) || this;
        _this._adaptee = adaptee || new AwayGraphics();
        _this._adaptee.adapter = _this;
        return _this;
    }
    Graphics.prototype.dispose = function () {
    };
    Object.defineProperty(Graphics.prototype, "adaptee", {
        get: function () {
            return this._adaptee;
        },
        enumerable: false,
        configurable: true
    });
    Graphics.FromData = function (data, loaderInfo) {
        var graphics = new this.sec.flash.display.Graphics();
        return graphics;
    };
    /*
    public getGraphicsData(): ShapeData {
        return this._graphicsData;
    }

    public getUsedTextures(): BitmapData[] {
        return this._textures;
    }*/
    Graphics.prototype.clear = function () {
        this.adaptee.clear();
    };
    /**
     * Sets a solid color and opacity as the fill for subsequent drawing commands.
     *
     * @see
     * http://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/display/Graphics.html#beginFill%28%29
     * @param color
     * @param alpha While any Number is a valid input, the value is clamped to [0,1] and then scaled
     * to an integer in the interval [0,0xff].
     */
    Graphics.prototype.beginFill = function (color /*uint*/, alpha) {
        if (alpha === void 0) { alpha = 1; }
        if (alpha < 0)
            alpha = 0;
        if (alpha > 1)
            alpha = 1;
        this.adaptee.beginFill(color, alpha);
    };
    Graphics.prototype.beginGradientFill = function (type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
        if (matrix === void 0) { matrix = null; }
        if (spreadMethod === void 0) { spreadMethod = 'pad'; }
        if (interpolationMethod === void 0) { interpolationMethod = 'rgb'; }
        if (focalPointRatio === void 0) { focalPointRatio = 0; }
        this.adaptee.beginGradientFill(type, colors.value, alphas.value, ratios.value, matrix === null || matrix === void 0 ? void 0 : matrix.adaptee, spreadMethod, interpolationMethod, focalPointRatio);
    };
    Graphics.prototype.beginBitmapFill = function (bitmap, matrix, repeat, smooth) {
        if (matrix === void 0) { matrix = null; }
        if (repeat === void 0) { repeat = true; }
        if (smooth === void 0) { smooth = false; }
        this.adaptee.beginBitmapFill(bitmap.adaptee, matrix === null || matrix === void 0 ? void 0 : matrix.adaptee, repeat, smooth);
    };
    Graphics.prototype.endFill = function () {
        this.adaptee.endFill();
    };
    //    beginShaderFill(shader: flash.display.Shader, matrix: flash.geom.Matrix = null): void {
    //      //shader = shader; matrix = matrix;
    //      release || notImplemented("public flash.display.Graphics::beginShaderFill"); return;
    //    }
    Graphics.prototype.lineStyle = function (thickness, color, alpha, pixelHinting, scaleMode, caps, joints, miterLimit) {
        if (color === void 0) { color = 0; }
        if (alpha === void 0) { alpha = 1; }
        if (pixelHinting === void 0) { pixelHinting = false; }
        if (scaleMode === void 0) { scaleMode = 'normal'; }
        if (caps === void 0) { caps = null; }
        if (joints === void 0) { joints = null; }
        if (miterLimit === void 0) { miterLimit = 3; }
        this.adaptee.lineStyle(thickness, color, alpha, pixelHinting, scaleMode, caps, joints, miterLimit);
    };
    Graphics.prototype.lineGradientStyle = function (type, colors, alphas, ratios, matrix, spreadMethod, interpolationMethod, focalPointRatio) {
        if (matrix === void 0) { matrix = null; }
        if (spreadMethod === void 0) { spreadMethod = 'pad'; }
        if (interpolationMethod === void 0) { interpolationMethod = 'rgb'; }
        if (focalPointRatio === void 0) { focalPointRatio = 0; }
        this.adaptee.lineGradientStyle(type, colors.value, alphas.value, ratios.value, matrix === null || matrix === void 0 ? void 0 : matrix.adaptee, spreadMethod, interpolationMethod, focalPointRatio);
    };
    Graphics.prototype.lineBitmapStyle = function (bitmap, matrix, repeat, smooth) {
        if (matrix === void 0) { matrix = null; }
        if (repeat === void 0) { repeat = true; }
        if (smooth === void 0) { smooth = false; }
        this.adaptee.lineBitmapStyle(bitmap.adaptee, matrix === null || matrix === void 0 ? void 0 : matrix.adaptee, repeat, smooth);
    };
    Graphics.prototype.drawRect = function (x, y, width, height) {
        this.adaptee.drawRect(x, y, width, height);
    };
    Graphics.prototype.drawRoundRect = function (x, y, width, height, ellipseWidth, ellipseHeight) {
        this.adaptee.drawRoundRect(x, y, width, height, ellipseWidth, ellipseHeight);
    };
    Graphics.prototype.drawRoundRectComplex = function (x, y, width, height, topLeftRadius, topRightRadius, bottomLeftRadius, bottomRightRadius) {
        this.adaptee.drawRoundRectComplex(x, y, width, height, topLeftRadius, topRightRadius, bottomLeftRadius, bottomRightRadius);
    };
    Graphics.prototype.drawCircle = function (x, y, radius) {
        this.adaptee.drawCircle(x, y, radius);
    };
    /**
     * Here x and y are the top-left coordinates of the bounding box of the
     * ellipse not the center as is the case for circles.
     */
    Graphics.prototype.drawEllipse = function (x, y, width, height) {
        this.adaptee.drawEllipse(x, y, width, height);
    };
    Graphics.prototype.moveTo = function (x, y) {
        this.adaptee.moveTo(x, y);
    };
    Graphics.prototype.lineTo = function (x, y) {
        this.adaptee.lineTo(x, y);
    };
    Graphics.prototype.curveTo = function (controlX, controlY, anchorX, anchorY) {
        this.adaptee.curveTo(controlX, controlY, anchorX, anchorY);
    };
    Graphics.prototype.cubicCurveTo = function (controlX1, controlY1, controlX2, controlY2, anchorX, anchorY) {
        this.adaptee.cubicCurveTo(controlX1, controlY1, controlX2, controlY2, anchorX, anchorY);
    };
    Graphics.prototype.copyFrom = function (sourceGraphics) {
        this.adaptee.copyFrom(sourceGraphics.adaptee);
    };
    Graphics.prototype.drawPath = function (commands, data, winding) {
        if (winding === void 0) { winding = 'evenOdd'; }
        //@ts-ignore
        this.adaptee.drawPath(commands._buffer.slice(0, commands.length), data._buffer.slice(0, data.length), winding);
    };
    Graphics.prototype.drawTriangles = function (vertices, indices, uvtData, culling) {
        if (indices === void 0) { indices = null; }
        if (uvtData === void 0) { uvtData = null; }
        if (culling === void 0) { culling = 'none'; }
        // @todo
        Debug.throwPIR('playerglobals/display/Graphics', 'drawTriangles', '');
    };
    Graphics.prototype.drawGraphicsData = function (graphicsData) {
        // @todo
        Debug.throwPIR('playerglobals/display/Graphics', 'drawGraphicsData', '');
    };
    Graphics.prototype.readGraphicsData = function (graphicsData) {
        // @todo
        Debug.throwPIR('playerglobals/display/Graphics', 'readGraphicsData', '');
        return [];
    };
    Graphics.classInitializer = null;
    return Graphics;
}(ASObject));
export { Graphics };
